module.exports = __webpack_public_path__ + "assets/img/partner-with-confidence_vector.422289d3.svg";